<template>
  <b-tab
    :disabled="disabled"
    :title-item-class="titleItemClass"
    @click="$emit('tabClick', tabName)"
  >
    <template #title>
      <slot name="title"></slot>
    </template>

    <slot></slot>
  </b-tab>
</template>

<script>
export default {
  name: "ClienteRuralTabItem",
  props: {
    disabled: Boolean,
    titleItemClass: {
      type: String,
      default: "mb-0",
    },
    tabName: String,
  },
};
</script>
